export const CSSRPromptText = {
  HEADING: "Consider administering the C-SSRS",
  BODY: "screened positive for suicidal thinking (question 9 on PHQ9). As clinical best practice, consider further evaluation using the Columbia-Suicide Severity Rating Scale (C-SSRS).",
  CALL_TO_ACTION: "Administer C-SSRS",
};
